// NOTE: Shepherd depends on `window.dbs.globalEvents`.
//
// 1. Add items to the Shepherd queue with:
// `window.dbs.globalEvents.emit('shepherdQueue', 'exampleUniqueName')`
//
// 2. Listen to Shepherd to kno when you should run your items function:
// `window.dbs.globalEvents.subscribe('shepherdItem', 'exampleUniqueName')`
//
// 3. Tell Shepherd you're done, so it can handle the next item:
// `window.dbs.globalEvents.emit('shepherdDone', 'exampleUniqueName')`

window.dbs = window.dbs || {}
dbs.shepherd = dbs.shepherd || {}

dbs.shepherd.itemQueue = []

dbs.shepherd.init = function () {
  let isShepherdBusy = false

  const shepherdNextItem = function () {
    let nextItem = dbs.shepherd.itemQueue.pop()

    if (nextItem) {
      if (process.env.NODE_ENV === 'development') {
        console.log('shepherdNextItem', nextItem)
      }

      isShepherdBusy = true
      return window.dbs.globalEvents.emit('shepherdNext', nextItem)
    }

    if (process.env.NODE_ENV === 'development') {
      console.log('shepherdNextItem is all DONE!!!')
    }

    isShepherdBusy = false
  }

  window.dbs.globalEvents.subscribe('shepherdQueue', function (uid) {
    if (dbs.shepherd.itemQueue.includes(uid)) return
    dbs.shepherd.itemQueue.unshift(uid) // add to queue

    if (process.env.NODE_ENV === 'development') {
      console.log('[SHEPHERD]', 'ADD', uid)
    }

    if (isShepherdBusy) return
    shepherdNextItem()
  })

  window.dbs.globalEvents.subscribe('shepherdDone', function (uid) {
    if (process.env.NODE_ENV === 'development') {
      console.log('[SHEPHERD]', 'DONE', uid)
      console.log('[SHEPHERD]', 'itemQueue?', dbs.shepherd.itemQueue)
    }

    // `setTimeout` to ensures the previous function is 100% completed.
    // - fixes next modal flashing its page dimmer on transition in.
    setTimeout(() => shepherdNextItem(), 5)
  })
}

window.dbs.shepherd.init()
